import plur from "plur";
import { toast } from "@jsq/ds/core";
import { useEndArenaAccessMutation } from "~/graphql/supergraphHooks";
import { toGlobalId } from "~/utils/graphql-helpers";

type EndArenaAccessParams = {
  arenaIds: string[];
  userIds: string[];
};

export const useRemoveWorkspaceAccessModal = ({ onClose }: { onClose: () => void }) => {
  const [endArenaAccess, { loading }] = useEndArenaAccessMutation();

  const removeWorkspaceAccess = async ({ arenaIds, userIds }: EndArenaAccessParams) => {
    const globalArenaIds = arenaIds.map((id) => toGlobalId("ArenaObjectType", id));
    const globalUserIds = userIds.map((id) => toGlobalId("UserObjectType", id));

    const errorMsg = `Failed to remove ${plur("user", userIds.length)} from ${plur("workspace", arenaIds.length)}`;
    const successMsg = `${plur("User", userIds.length)} removed from ${plur("workspace", arenaIds.length)}`;

    try {
      const response = await endArenaAccess({
        fetchPolicy: "network-only",
        variables: {
          input: {
            arenaIds: globalArenaIds,
            userIds: globalUserIds,
          },
        },
        refetchQueries: ["ArenaAccessForUser", "ActiveArenaAccesses"],
      });
      const data = response.data?.endArenaAccess;

      if (data?.__typename === "EndArenaAccessResponse") {
        toast.success(successMsg);
        onClose();
      } else if (data?.__typename === "MutationErrorResponse") {
        toast.error(data.message);
      } else {
        toast.error("There was an error with the operation");
      }
    } catch {
      toast.error(errorMsg);
    }
  };

  return {
    removeWorkspaceAccess,
    loading,
  };
};
